var React = require('react');

function Snooze (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.85901 3.99249V6.31799L7.68701 7.43249","stroke":"#424242","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.99995 1.61749C6.12095 1.41599 5.17445 1.47249 4.27845 1.84399C1.98295 2.79499 0.892954 5.42649 1.84345 7.72199C2.79395 10.0175 5.42595 11.1075 7.72145 10.157C9.77945 9.30449 10.8635 7.10149 10.3815 5.00049","stroke":"#424242","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9 1H10.5L9 3H10.5","stroke":"#424242","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Snooze.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Snooze;

Snooze.default = Snooze;
